import type { Router } from 'vue-router'

const RELOAD_KEY = 'erp:route-load-recovery'
const RETRY_INTERVAL = 60_000

/** Lazy pages can disappear after deployment, or fail on an interrupted connection. */
export function installLoadRecovery(router: Router, browser: Window = window): void {
  router.onError((error, to) => {
    const message = error instanceof Error ? error.message : String(error)
    if (!/Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i.test(message)) {
      console.error(error)
      return
    }

    // Keep the guard across reloads. If storage is unavailable, avoid an
    // automatic reload we cannot guard against repeating.
    try {
      const last = Number(browser.sessionStorage.getItem(RELOAD_KEY))
      const now = Date.now()
      if (!last || now - last >= RETRY_INTERVAL) {
        browser.sessionStorage.setItem(RELOAD_KEY, String(now))
        // The failed navigation has not changed the URL yet. Open the page
        // the user clicked, including its query/hash, with the current bundle.
        browser.location.assign(router.resolve(to).href)
        return
      }
    } catch {
      // Storage may be disabled by browser privacy settings.
    }

    console.error(error)
    browser.alert('Страницата не можа да се зареди. Проверете връзката си и презаредете страницата.')
  })
}
